export default __webpack_public_path__ + "static/media/Lluvia_torrencial.6edeb279.svg";